<template>
    <div>
        <InitiativeDashboard />
        <Initiatives :initiatives="Initiatives" />
    </div>
</template>

<script>
import { Initiatives } from '@/views/okr/list'
import InitiativeDashboard from '@/views/okr/initiatives/dashboard'

export default {
    name: 'MyInitiatives',
    components: {
        Initiatives,
        InitiativeDashboard,
    },
    computed: {
        Initiatives() {
            return this.$store.getters['daily/getInitiatives']
        },
    },
}
</script>
